"use client";
import React, { useContext } from "react";
import Image from "next/image";
import calling from "@/assets/img/icon/calling.svg";
import languageImage from "@/assets/img/icon/language.svg";
import { ifArabic, setLanguage, switchLanguageInUrl } from "@/utils/language";
import { setCookie } from "cookies-next";
import Link from "next/link";
import { LanguageContext } from "@/app/[lang]/client/language-context";
import { useRouter, usePathname } from "next/navigation";

export default function HeaderTopArea({ headerTwo }: { headerTwo?: boolean }) {
  const language = useContext(LanguageContext);
  const router = useRouter();
  const pathname = usePathname();

  return (
    <div className="tp-header-top theme-bg">
      <div className="container">
        <div className="row">
          <div
            className={`${ifArabic(
              "top-header d-flex align-items-center justify-content-start",
              ""
            )} ${headerTwo ? "second-top-header-1" : "top-header-1"}`}
          >
            <div className="tp-heder-info d-flex justify-content-center justify-content-lg-start align-items-center">
              <div className="tp-header-info-item ">
                <span>
                  <Link
                    aria-label="Email"
                    href={
                      headerTwo
                        ? "mailto:advancement@htu.edu.jo"
                        : "mailto:info@htu.edu.jo"
                    }
                  >
                    <i className="fa-regular fa-envelope"></i>
                    {headerTwo ? "advancement@htu.edu.jo" : "info@htu.edu.jo"}
                  </Link>
                </span>
              </div>
              <div className="tp-header-info-item">
                <span
                  style={{
                    fontFamily: "ScalaSansPro",
                  }}
                >
                  <Link
                    aria-label="Phone"
                    href={`tel:${headerTwo ? "+96265808779" : "+96265808787"}`}
                  >
                    <i>
                      <Image src={calling} alt="htu number" />
                    </i>{" "}
                    {headerTwo ? "+(962) 6 580 8779" : "+(962) 6 580 8787"}
                  </Link>
                </span>
              </div>
              <div className="tp-header-info-item">
                <span>
                  <button
                    onClick={() => {
                      const newLang = language?.language == "ar" ? "en" : "ar";

                      // Update language context and cookie
                      language.changeLanguage(newLang);
                      setLanguage(newLang);
                      setCookie("lang", newLang);

                      // Navigate to the new URL with updated language
                      const newUrl = switchLanguageInUrl(pathname, newLang);
                      router.push(newUrl);
                    }}
                  >
                    <i className="mb-10">
                      <Image
                        src={languageImage}
                        alt="htu number"
                        width={19}
                        height={19}
                      />
                    </i>{" "}
                    {language?.language == "ar" ? "English" : "العربية"}
                  </button>
                </span>
                {/* <span>
                  <a href="tel:+962 6 580 8787">
                    <i>
                      <Image src={calling} alt="htu number" />
                    </i>{" "}
                    +(962) 6 580 8787
                  </a>
                </span> */}
              </div>
            </div>
          </div>

          <div
            className={`d-none d-lg-block ${
              headerTwo ? "second-top-header-2" : "top-header-2"
            }`}
          >
            <div className="tp-header-right-list d-flex justify-content-md-end">
              <a
                aria-label="Employee Portal"
                href="https://eis.htu.edu.jo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ifArabic("بوابة الموظف", "Employee Portal")}
              </a>
              <a
                aria-label="Student Portal"
                href="https://sis.htu.edu.jo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ifArabic("بوابة الطالب", "Students Portal")}
              </a>
              <a
                aria-label="E-learning"
                href="https://elearning.htu.edu.jo/login/index.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ifArabic("التعلم الإلكتروني", "E-learning")}
              </a>
              <a
                aria-label="Pearson Support Hub"
                href="https://www.htu.edu.jo/Pearson/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {ifArabic("مركز دعم بيرسون", "Pearson Support Hub")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
